/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { NotificationSummary, PagedSortedFilteredRequestParams, SortColumn } from '@centecomm/portal-service';
import { useNotification } from '@centecomm/portal-service-react';
import { ArrowLeftCircle, IconColors } from 'Icons';
import { Button } from 'Shared/Button/Button';
import { Types as TableTypes } from 'Shared/Table';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Details from '../Details/NotificationDetails';
import NotificationsList from '../NotificationsList';
import ClearAllNotificationsButton from '../ClearAllNotificationsButton';
import styles from '../notifications-panel.module.css';
import { PageWrapper } from '../../../Shared/PageWrapper';
import { FlexWrapper } from '../../../Shared/FlexWrapper';

const sortColumn: SortColumn[] = [{ columnName: 'Id', sortDirection: TableTypes.SortDirection.DESC }];

function NotificationsPage(): React.ReactElement {
    const [notifications, setNotifications] = useState<NotificationSummary[]>([]);
    const [selectedNotificationId, setSelectedNotificationId] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const { t } = useTranslation('notificationsFeature');

    const { getAllNotifications } = useNotification();

    const loadMoreNotifications = () => {
        getAllNotifications(new PagedSortedFilteredRequestParams(sortColumn, [], 10, currentPage)).then(
            (notificationSummaries: NotificationSummary[]) => {
                setNotifications(notifications.concat(notificationSummaries));
                setCurrentPage(currentPage + 1);
            },
        );
    };

    React.useEffect(() => {
        if (!selectedNotificationId) loadMoreNotifications();
    }, []);

    const showNotificationDetails = (notificationId: number) => {
        setSelectedNotificationId(notificationId);
    };

    const removeNotification = (notificationId: number) => {
        setNotifications(notifications.filter(({ id }) => id !== notificationId));
    };

    const clearAll = () => {
        getAllNotifications(new PagedSortedFilteredRequestParams(sortColumn, [], 10, 1)).then(
            (notificationSummaries: NotificationSummary[]) => {
                setNotifications(notificationSummaries);
                setCurrentPage(1);
            },
        );
    };

    return (
        <PageWrapper pageTitle={t('notificationsFeature:title')}>
            <FlexWrapper justify="between" align="center" fullWidth style={{ marginBottom: '2rem' }}>
                <h1 style={{ margin: 0, lineHeight: 1 }}>{t('notificationsFeature:title')}</h1>
                {!selectedNotificationId && <ClearAllNotificationsButton clearAllCallback={clearAll} />}
            </FlexWrapper>
            {selectedNotificationId ? (
                <>
                    <button
                        type="button"
                        className={styles.Action}
                        onClick={() => {
                            setSelectedNotificationId(0);
                        }}
                    >
                        <ArrowLeftCircle aspect="1.5rem" color={IconColors.Action} />
                        <p style={{ color: 'var(--color-Action' }}>
                            <b>{t('notificationsFeature:backToList')}</b>
                        </p>
                    </button>
                    <Details notificationId={selectedNotificationId} removeNotification={removeNotification} />
                </>
            ) : (
                <>
                    <NotificationsList notifications={notifications} handleSelect={showNotificationDetails} />
                    <Button
                        callback={loadMoreNotifications}
                        text={t('notificationsFeature:loadMore')}
                        fullWidth
                        withMarginTop
                    />
                </>
            )}
        </PageWrapper>
    );
}

export default NotificationsPage;
